<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">服务类目：</span>
        </div>
        <el-select v-model="formData.parentItemCode" size="small" style="width: 280px">
          <el-option v-for="item in valueAddItemList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">子类目：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">子类目：</span>-->
        <!--</div>-->
        <!--<div style="display: flex;justify-content: flex-start;flex-direction: column;">-->
          <!--<div v-for="(item, index) in formData.valueaddItemChildList" style="display: flex;justify-content: flex-start;margin-bottom: 10px;">-->
            <!--<el-input v-model="item.name" size="small" style="width: 280px" />-->
            <!--<div style="margin-left: 20px;display: flex;justify-content: flex-start">-->
              <!--<i class="el-icon-remove-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;margin-right: 20px;color: #f25721;" @click="removeValueaddItemChild(index)" v-if="index !== 0"></i>-->
              <!--<i class="el-icon-circle-plus-outline" style="line-height: 33px; font-size: 24px; cursor: pointer;color: #00A0E6;" @click="addValueaddItemChild" v-if="index === formData.valueaddItemChildList.length - 1"></i>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/ValueAdded'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'service-category-modify',
    data () {
      return {
        breadcrumb: [{
          value: '严选服务',
          name: 'service-over-view'
        }, {
          value: '服务类目'
        }],
        mainTitle: '修改子类目',
        subheading: '',

        itemList: [],
        pictureBase64: '',
        hsbzState: false,
        valueAddItemList: [],
        formData: {
          code: '',
          name: '',
          parentItemCode: '',
          parentItemName: '',
        },
        accountList: [],
        responsiblePersonList: [],
      }
    },
    created () {
      this.getValueAddItemList()
      this.getValueAddItemChildByCode(this.$route.params.id)
    },
    methods: {
      getValueAddItemList () {
        this.$axios.post(api.getValueAddItemList, {})
          .then(res => {
            this.valueAddItemList = res.data.data
          })
          .catch(errorHandler('获取失败'))
      },
      getValueAddItemChildByCode (code) {
        this.$axios.get(`${api.getValueAddItemChildByCode}/${code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let resData = res.data.data
              this.formData = resData
            }
          })
          .catch(errorHandler('查询失败'))
      },
      toManagePage () {
        this.$router.push({
          name: 'service-category-manage'
        })
      },

      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        if (file.size > 1024 * 1024) {
          nError('上传图片不能大于1M')
          return false
        }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.formData.itemPic = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },

      // 增加子类目
      addValueaddItemChild () {
        let obj = {
          code: '',
          name: ''
        }
        this.formData.valueaddItemChildList.push(obj)
      },

      // 删除子类目
      removeValueaddItemChild (index) {
        this.formData.valueaddItemChildList.splice(index, 1)
      },

      confirm () {
        if (!this.formData.parentItemCode) {
          nError('请选择服务类目')
          return false
        }
        if (!this.formData.name) {
          nError('请输入子类目名称')
          return false
        }
        this.valueAddItemList.map(v => {
          if (v.code === this.formData.parentItemCode) {
            this.formData.parentItemName = v.name
          }
        })
        this.$axios.post(api.updateValueAddItemChildDetail, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toManagePage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/ValueAddedService/ServiceCategory/ServiceCategoryModify.vue